module.exports = __webpack_public_path__ + "6fd533321a2d1da4f1b5893f4c1396ea.svg";